import Box from '@mui/material/Box'
import React from 'react'

export const Header = () => {
  return <Box sx={{ pt: 8 }}></Box>
}
